import React from 'react'
import { FeatureImage } from 'js/components/FeatureImage'
import Container from 'js/pages/LandingPages/components/Container'
import { pushToDataLayer } from 'js/pages/LandingPages/utils'
import { SharedSectionProps } from './types'
import LSButton from 'js/components/LSButton'
import { APP_STORE_LINK } from '../content'
import cn from 'classnames'

type ResponsiveImage = {
  src: string
  width: number
  height: number
}
type Props = {
  label: string | null
  title: string | null
  subtitle: string | null
  items: {
    text: string | null
  }[]
  image: {
    responsiveImage: ResponsiveImage
  } | null
} & SharedSectionProps

const Hero = ({
  label,
  title,
  subtitle,
  items,
  image,
  downloadLinkText,
  signupLinkText,
  downloadLinkFirst,
  onOpenModal,
}: Props) => {
  const handleOpenModal = () => {
    pushToDataLayer({
      event: 'click_event',
      click_type: 'button',
      click_text: downloadLinkText?.toLowerCase(),
      action: undefined,
      location: title?.toLowerCase(),
    })
    onOpenModal(true)
  }

  const mobileClasses = 'mb-16 ml-0 block lg:hidden'
  return (
    <section className="lg:pt-66">
      <Container>
        <div className="grid auto-rows-auto gap-x-[40px] lg:grid-cols-2 lg:grid-rows-1">
          <div className="relative order-1 pt-24 lg:pt-0">
            <span className="text-17 font-demibold uppercase leading-23 tracking-1.36">
              {label}
            </span>
            <h1 className="quincy text-40 leading-44 tracking-heading text-black lg:text-64 lg:leading-75">
              {title}
            </h1>
            <p className="quincy pt-24 text-20 leading-23 text-black lg:pt-40 lg:text-28 lg:leading-32">
              {subtitle}
            </p>
            <ul className="-m--18 pb-16 pt-36 sm:pb-0 lg:pt-58">
              {items.map((item) => (
                <li
                  key={item.text}
                  className="quincy list-outside list-disc pb-20 pl-[10px] text-17 leading-23 lg:pb-24 lg:text-20"
                >
                  {item.text}
                </li>
              ))}
            </ul>
            <div className="flex flex-col lg:flex-wrap lg:items-start">
              <LSButton
                link
                variant="primary"
                size="large"
                upperCase
                href="/signup?code=50web23"
                className={'mb-16 ml-0 hidden lg:block'}
                onClick={() =>
                  pushToDataLayer({
                    event: 'click_event',
                    click_type: 'button',
                    click_text: 'sign up now',
                    action: undefined,
                    location: title?.toLowerCase(),
                  })
                }
              >
                {signupLinkText}
              </LSButton>

              <LSButton
                link={false}
                variant="secondary"
                size="large"
                upperCase
                className="relative ml-0 hidden w-full py-[19px] md:w-auto lg:block lg:py-[14.5px]"
                onClick={handleOpenModal}
              >
                {downloadLinkText}
              </LSButton>
              <>
                <LSButton
                  link
                  size="large"
                  href={APP_STORE_LINK}
                  variant={downloadLinkFirst ? 'primary' : 'secondary'}
                  upperCase
                  className={cn(
                    mobileClasses,
                    downloadLinkFirst ? 'order-2' : 'order-3',
                  )}
                  onClick={() =>
                    pushToDataLayer({
                      event: 'click_event',
                      click_type: 'button',
                      click_text: 'download',
                      action: undefined,
                      location: title?.toLowerCase(),
                    })
                  }
                >
                  {downloadLinkText}
                </LSButton>
                <LSButton
                  link
                  variant={downloadLinkFirst ? 'secondary' : 'primary'}
                  size="large"
                  upperCase
                  href="/signup"
                  className={cn(
                    mobileClasses,
                    downloadLinkFirst ? 'order-3' : 'order-2',
                  )}
                  onClick={() =>
                    pushToDataLayer({
                      event: 'click_event',
                      click_type: 'button',
                      click_text: 'sign up now',
                      action: undefined,
                      location: title?.toLowerCase(),
                    })
                  }
                >
                  {signupLinkText}
                </LSButton>
              </>
            </div>
          </div>
          <FeatureImage
            image={{ ...image?.responsiveImage } as ResponsiveImage}
            className="relative -order-1 mt-32 w-full rounded-6 lg:order-1 lg:mt-20"
          />
        </div>
      </Container>
    </section>
  )
}

export default Hero
